































import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";

/*
    * Method for pupulate text input control - STARTS
    1. id - Current field name
    2. field - text field with properties
*/

/*
    * Component's variables
*/
@Component({})

export default class FileComponent extends Vue  {
    /*
        * Component's props
    */
    @Prop() readonly create!: string;
    @Prop() readonly edit!: string;
    @Prop() readonly title!: string;
    @Prop() readonly disabled!: string;
    @Prop() readonly columns!: string;
    @Prop() readonly record!: string;
    @Prop() readonly fieldName!: string;
    @Prop() readonly prefix!: string;
    @Prop() readonly parentName!: string;
    @Prop() readonly suffix!: string;
    @Prop() readonly showInputs!: string;
    @Prop() readonly formCreate!: string;
    @Prop() readonly readonly!: string;
    @Prop() readonly accept!: string;
    @Prop() readonly multiple!: string;
    @Prop() readonly required!: string;
    @Prop() readonly hint!: string;
    @Prop() readonly browserAutocomplete!: string;
    @Prop() readonly rules!: string;
    @Prop() readonly inline!: string;

    /*
        * Component's variables
    */
    private translateKey: string = "";

    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  tooltipIcon - tootip icon show in mouseover
        *  tooltipOption - tootip dialog show in mouseover
        *  translateKey - translated key field
    */
    data() {
        return { translateKey: "" };
    }

    getFormData(files) {
        const data = new FormData();
        [...files].forEach(file => {
            data.append('file', file, file.name); // currently only one file at a time
        });
        return data;
    }

    onFocus() {
        if (!this.disabled) {
            let fileInput: HTMLElement = this.$refs.fileInput as HTMLElement;
            fileInput.click();
        }
    }

    CalculateFileSize() {
        var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
            i = 0;
        let size = 0;
        while (size > 900) {
            size /= 1024;
            i++;
        }
        var exactSize = (Math.round(size * 100) / 100) + ' ' + fSExt[i];
        return exactSize;
    }

    onFileChange($event) {
        //#.Trigger changes
        this.$emit('reset');
        const files = $event.target.files || $event.dataTransfer.files;
        const form = this.getFormData(files);
        let fileNames: string | null = null;
        if (files) {
            if (files.length > 0) {
                fileNames = [...files].map(file => file.name).join(', ');
            } else {
                fileNames = null;
            }
        } else {
            fileNames = $event.target.value.split('\\').pop();
        }

        var context = this.$store.state[this.parentName];
        context.isDirty = true;

        //#. Remove component in the DOM
        context.fields.find(x => x.type == 'File').create = false;

        //#. Add component back-in
        Vue.nextTick(() => {
            context.fields.find(x => x.type == 'File').create = true;
        });

        context.editedItem["FormData"] = form;
        this.$emit('input', fileNames);

        //#.If checking event true annotation is enable.	
        // @ts-ignore
        if (this.$attrs.field.event) {
            // @ts-ignore
            let action = this.$attrs.field.value;
            action = action.charAt(0).toLowerCase() + action.slice(1);
            //#.Change is triggered with the store.dispatch method.	
            // @ts-ignore
            this.$store.dispatch(context.fileName + '/' + action + 'Change', $event);
        }

        if (context.inlineEditor.enabled)
            context.isDirty = true;
    } 

    /*
        *  Key translator
    */
    get translator(): string {
        let context = this.$store.state[this.parentName];

        if (context && !context.keyTranslator) {
            this.translateKey = this.title;
            return this.translateKey;
        }

        this.translateKey = (this.$t(this.title) || this.title).toString();
        return this.translateKey;
    }
};
